import React from 'react';

interface WhenProps {
  condition: boolean | (() => boolean);
}

export const When: React.FC<WhenProps> = ({ condition, children }) => {
  if (typeof condition === 'function') {
    return condition() ? children : (null as any);
  }

  return condition ? children : (null as any);
};
